<ng-container *transloco="let t">
  <div class="main-content">
    <div class="data-section" id="data-section">
      <div class="title-row">
        <h3>{{ t(TITLE) }}</h3>

        <div class="tab-headers-container">
          <div
            class="tab-header"
            pRipple
            (click)="setActiveTab('manage')"
            [class.active]="activeTab === 'manage'"
          >
            <span class="material-symbols-outlined icon">list</span>
            <span class="label">{{ t("management") }}</span>
          </div>
          <div
            class="tab-header"
            pRipple
            (click)="setActiveTab('history')"
            [class.active]="activeTab === 'history'"
          >
            <span class="material-symbols-outlined icon">history</span>
            <span class="label">{{ t("history") }}</span>
          </div>
        </div>
      </div>

      <div class="tab-panels-container">
        <div class="tab-panel" [class.visible]="activeTab === 'manage'">
          <div class="actions-row">
            <p-button
              [icon]="
                'pi pi-refresh' +
                (((dataLoading$ | async) ?? true) ? ' pi-spin' : '')
              "
              [disabled]="(dataLoading$ | async) ?? true"
              (click)="refreshData()"
            />

            <!-- <p-button
              icon="pi pi-filter"
              severity="info"
              [outlined]="!filtersDialogVisible"
              [disabled]="(dataLoading$ | async) ?? true"
              (click)="toggleFilters()"
              [label]="appliedFiltersCount"
            /> -->

            <input
              #dataSearch
              type="text"
              pInputText
              id="search-input"
              (input)="dataTable.filterGlobal(dataSearch.value, 'contains')"
              [placeholder]="t(SEARCH_PLACEHOLDER)"
              class="search-input"
            />

            <p-button
              icon="pi pi-sparkles"
              [disabled]="((predictionsLoading$ | async) ?? true) || ((rebalancingLoading$ | async) ?? true)"
              [loading]="(predictionsLoading$ | async) ?? true"
              (click)="calculatePredictions()"
              [label]="t('calculatePredictions')"
              severity="info"
              [outlined]="true"
            />

            <p-button
              icon="pi pi-play"
              [disabled]="((predictionsLoading$ | async) ?? true) || ((rebalancingLoading$ | async) ?? true)"
              [loading]="(rebalancingLoading$ | async) ?? true"
              (click)="startRebalancing()"
              [label]="t('startRebalancing')"
              severity="help"
              [outlined]="true"
            />
          </div>

          <p-skeleton
            class="skeleton-loader"
            height="100%"
            width="100%"
            [class.visible]="(dataLoadingUI$ | async) ?? true"
          />

          <p-table
            #dataTable
            class="table"
            id="table"
            [value]="data"
            [(selection)]="selectedRows"
            [rowHover]="true"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
            sortMode="single"
            [selectionMode]="null"
            [rowTrackBy]="_dataTrackBy"
            [metaKeySelection]="true"
            [resizableColumns]="true"
            columnResizeMode="fit"
            [globalFilterFields]="dataFilterFields"
            stripedRows
            [scrollable]="true"
            [class.visible]="!((dataLoadingUI$ | async) ?? true)"
          >
            <ng-template #header>
              <tr>
                <!-- <th style="width: 3rem"><p-tableHeaderCheckbox /></th> -->

                @for (col of columns; track col.field) {
                  @if (col.visible ?? true) {
                    <th [pSortableColumn]="col.field" pResizableColumn>
                      <div class="table-header-row">
                        <span class="header-label">{{
                          t(col.header, col.headerParams)
                        }}</span>
                        <div class="header-buttons">
                          <p-sortIcon [field]="col.field" />
                        </div>
                      </div>
                    </th>
                  }
                }
              </tr>
            </ng-template>
            <ng-template #body let-record let-rowIndex="rowIndex">
              <tr
                [pSelectableRow]="record"
                [pSelectableRowIndex]="rowIndex"
                (contextmenu)="$event.preventDefault()"
              >
                <!-- <td (click)="$event.stopPropagation()">
                  <p-tableCheckbox [value]="record" />
                </td> -->
                @for (col of columns; track col.field) {
                  @if (col.visible ?? true) {
                    <td>
                      <!-- CELLA -->
                      @if (col.wrapper) {
                        <ng-container
                          *ngComponentOutlet="
                            col.wrapper;
                            inputs: parseWrapperInputs(col, [
                              record,
                              getCellData(col, record),
                            ])
                          "
                        ></ng-container>
                      } @else {
                        <span [innerHTML]="getCellData(col, record)"></span>
                      }
                    </td>
                  }
                }
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="tab-panel" [class.visible]="activeTab === 'history'">
          <div class="actions-row">
            <p-button
              [icon]="
                'pi pi-refresh' +
                (((dataLoading2$ | async) ?? true) ? ' pi-spin' : '')
              "
              [disabled]="(dataLoading2$ | async) ?? true"
              (click)="refreshData2()"
            />

            <!-- <p-button
              icon="pi pi-filter"
              severity="info"
              [outlined]="!filtersDialogVisible"
              [disabled]="(dataLoading$ | async) ?? true"
              (click)="toggleFilters()"
              [label]="appliedFiltersCount"
            /> -->

            <input
              #dataSearch2
              type="text"
              pInputText
              id="search-input-2"
              (input)="dataTable2.filterGlobal(dataSearch2.value, 'contains')"
              [placeholder]="t(SEARCH_PLACEHOLDER_2)"
              class="search-input"
            />
          </div>

          <p-skeleton
            class="skeleton-loader"
            height="100%"
            width="100%"
            [class.visible]="(dataLoadingUI2$ | async) ?? true"
          />

          <p-table
            #dataTable2
            class="table"
            id="table"
            [value]="data2"
            [(selection)]="selectedRows2"
            [rowHover]="true"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
            sortMode="single"
            [selectionMode]="null"
            [rowTrackBy]="_dataTrackBy2"
            [metaKeySelection]="true"
            [resizableColumns]="true"
            columnResizeMode="fit"
            [globalFilterFields]="dataFilterFields2"
            stripedRows
            [scrollable]="true"
            [class.visible]="!((dataLoadingUI2$ | async) ?? true)"
          >
            <ng-template #header>
              <tr>
                <!-- <th style="width: 3rem"><p-tableHeaderCheckbox /></th> -->

                @for (col of columns2; track col.field) {
                  @if (col.visible ?? true) {
                    <th [pSortableColumn]="col.field" pResizableColumn>
                      <div class="table-header-row">
                        <span class="header-label">{{
                          t(col.header, col.headerParams)
                        }}</span>
                        <div class="header-buttons">
                          <p-sortIcon [field]="col.field" />
                        </div>
                      </div>
                    </th>
                  }
                }
              </tr>
            </ng-template>
            <ng-template #body let-record let-rowIndex="rowIndex">
              <tr
                [pSelectableRow]="record"
                [pSelectableRowIndex]="rowIndex"
                (contextmenu)="$event.preventDefault(); openFormDialog2(record)"
                (longPress)="openFormDialog2(record)"
                appLongPress
              >
                <!-- <td (click)="$event.stopPropagation()">
                  <p-tableCheckbox [value]="record" />
                </td> -->
                @for (col of columns2; track col.field) {
                  @if (col.visible ?? true) {
                    <td>
                      <!-- CELLA -->
                      @if (col.wrapper) {
                        <ng-container
                          *ngComponentOutlet="
                            col.wrapper;
                            inputs: parseWrapperInputs(col, [
                              record,
                              getCellData(col, record),
                            ])
                          "
                        ></ng-container>
                      } @else {
                        <span [innerHTML]="getCellData(col, record)"></span>
                      }
                    </td>
                  }
                }
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>

  <!--? FORM DIALOG  --------------------------------->
  <p-dialog
    [header]="t('rebalancingDetails')"
    [modal]="true"
    [(visible)]="formDialogVisible2"
    [style]="{ width: 'min(37rem, 90vw)', height: 'min(800px, 90dvh)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="form-dialog"
  >
    @if (formDialogData2) {
      @if (formDialogData2.status === "CALCULATING") {
        <div class="no-steps">
          <img src="assets/loading.gif" alt="Caricamento..." />
          <p class="no-steps-title">{{ t("elaborating") }}</p>
        </div>
      } @else if (formDialogData2.status === "FAILED") {
        <div class="no-steps">
          <p class="no-steps-title">{{ t("rebalancingFailed") }}</p>
          <p class="no-steps-text">{{ t("rebalancingFailedContent") }}</p>
        </div>
      } @else {
        <div class="rebalancing-steps-list">
          @for (
            step of formDialogData2.steps;
            track formDialogData2.historyId + step.stepIndex
          ) {
            <div
              class="rebalancing-step"
              [ngClass]="step.actionType"
              (click)="step.done = !(step.done ?? false)"
              [class.done]="step.done"
              pRipple
            >
              <div class="step-index">
                @if (step.done) {
                  <span class="material-symbols-outlined"> check </span>
                } @else {
                  @if ($last) {
                    <span class="material-symbols-outlined">
                      sports_score
                    </span>
                  } @else {
                    <span>{{ step.stepIndex + 1 }}</span>
                  }
                }
              </div>
              <div class="step-details">
                <p class="station-name">
                  {{ step.stationIdDetails.description }}
                </p>
                <p class="station-address">
                  {{ getStationAddressString(step.stationIdDetails) }}
                </p>
              </div>
              <div class="step-action">
                <span class="action-label">{{ t(step.actionType) }}</span>
                <div class="action-row">
                  <span class="action-amount">{{ step.actionAmount }}</span>
                  <span class="step-action-icon material-symbols-outlined">
                    @if (step.actionType == "pickup") {
                      arrow_upward
                    } @else {
                      arrow_downward
                    }
                  </span>
                </div>
              </div>
            </div>

            @if (!$last) {
              <div class="list-separator"></div>
            }
          } @empty {
            <div class="no-steps">
              <p class="no-steps-title">{{ t("noRebalancingSteps") }}</p>
              <p class="no-steps-text">{{ t("noRebalancingStepsContent") }}</p>
            </div>
          }
        </div>
      }
    }
    <ng-template #footer>
      @if ((formDialogData2?.steps ?? []).length > 2) {
        <p-button
          [label]="t('openIndications')"
          severity="info"
          (click)="openIndications()"
          [outlined]="true"
        />
      }

      <p-button
        [label]="t('close')"
        severity="secondary"
        (click)="hideFormDialog2()"
      />
    </ng-template>
  </p-dialog>
</ng-container>
